import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { apiService } from "../services/api";
import { mantenimientoService } from "../services/mantenimiento";

const MESES_I = ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'];
function fmtFechaI(ts) {
    if (!ts) return '—';
    const d = new Date(ts);
    return `${d.getDate()} ${MESES_I[d.getMonth()]} ${d.getFullYear()}`;
}
function fmtFechaStrI(str) {
    if (!str) return '—';
    const [y, m, d] = str.split('-');
    return `${d} ${MESES_I[parseInt(m) - 1]} ${y}`;
}
function fmtKmI(km) {
    return km != null ? km.toLocaleString('es-PE') + ' km' : '—';
}
function calcDiasI(fechaStr) {
    if (!fechaStr) return null;
    const hoy = new Date(); hoy.setHours(0, 0, 0, 0);
    const f   = new Date(fechaStr); f.setHours(0, 0, 0, 0);
    return Math.round((f - hoy) / 86400000);
}
function fmtDiasI(d) {
    if (d == null) return '—';
    if (d === 0) return 'Hoy';
    return d > 0
        ? `${d} día${d !== 1 ? 's' : ''}`
        : `Vencido hace ${Math.abs(d)} día${Math.abs(d) !== 1 ? 's' : ''}`;
}
const MANT_ST = {
    aldia:   { bg: '#dcfce7', color: '#15803d', label: 'Al día',           icon: 'bi-check-circle-fill' },
    proximo: { bg: '#fef9c3', color: '#b45309', label: 'Próximo a vencer', icon: 'bi-exclamation-circle-fill' },
    vencido: { bg: '#fee2e2', color: '#b91c1c', label: 'Vencido',          icon: 'bi-x-circle-fill' },
};
function stKmI(rest, tol) {
    if (rest <= 0) return 'vencido';
    if (tol != null && rest <= tol) return 'proximo';
    return 'aldia';
}
function stDiasI(dias, tol) {
    if (dias == null) return null;
    if (dias <= 0) return 'vencido';
    if (tol != null && dias <= tol) return 'proximo';
    return 'aldia';
}

const StatusPill = ({ status }) => {
    if (!status) return null;
    const s = MANT_ST[status];
    return (
        <span style={{
            display: 'inline-flex', alignItems: 'center', gap: '.28rem',
            fontSize: '.63rem', fontWeight: 700, letterSpacing: '.05em', textTransform: 'uppercase',
            padding: '.22rem .65rem', borderRadius: 100,
            background: s.bg, color: s.color, border: `1px solid ${s.color}33`,
        }}>
            <i className={`bi ${s.icon}`} style={{ fontSize: '.65rem' }}></i>{s.label}
        </span>
    );
};

const MantRow = ({ lbl, val }) => (
    <div style={{
        display: 'flex', justifyContent: 'space-between', alignItems: 'baseline',
        gap: '.5rem', padding: '.3rem 0', borderBottom: '1px solid #f1f5f9',
    }}>
        <span style={{ fontSize: '.72rem', color: '#334155', flexShrink: 0 }}>{lbl}</span>
        <span style={{ fontSize: '.77rem', fontWeight: 600, color: '#0f172a', textAlign: 'right' }}>{val}</span>
    </div>
);

const KmProgressBar = ({ pct, color }) => (
    <div style={{ margin: '.55rem 0 .6rem' }}>
        <div style={{ height: 5, borderRadius: 3, background: '#edf2f7', overflow: 'hidden' }}>
            <div style={{
                height: '100%', width: `${Math.max(0, Math.min(100, pct))}%`,
                background: color, borderRadius: 3, transition: 'width .5s ease',
            }} />
        </div>
    </div>
);

const BigMetric = ({ value, label, color, date, dateSub }) => (
    <div style={{ textAlign: 'center', padding: '.35rem 0 .65rem' }}>
        <div style={{ fontSize: '1.3rem', fontWeight: 800, letterSpacing: '-.03em', color, lineHeight: 1 }}>{value}</div>
        <div style={{ fontSize: '.68rem', color: '#475569', marginTop: '.22rem' }}>{label}</div>
        {date && (
            <div style={{ marginTop: '.55rem' }}>
                <span style={{
                    display: 'inline-flex', alignItems: 'center', gap: '.3rem',
                    background: '#f1f5f9', border: '1px solid #e2e8f0',
                    borderRadius: 100, padding: '.22rem .7rem',
                    fontSize: '.72rem', fontWeight: 600, color: '#334155',
                }}>
                    <i className="bi bi-calendar3" style={{ fontSize: '.62rem', color: '#64748b' }}></i>
                    {dateSub && <span style={{ fontWeight: 500, color: '#64748b' }}>{dateSub} </span>}
                    {date}
                </span>
            </div>
        )}
    </div>
);

function MantPreventivo({ mant }) {
    if (!mant || mant.encontrado === false) {
        return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '.5rem', color: '#475569', padding: '.25rem 0' }}>
                <i className="bi bi-calendar-x" style={{ fontSize: '.9rem' }}></i>
                <span style={{ fontSize: '.8rem' }}>Sin información disponible</span>
            </div>
        );
    }

    const SectionHdr = ({ label, status }) => (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '.5rem' }}>
            <span style={{ fontSize: '.65rem', fontWeight: 700, letterSpacing: '.09em', textTransform: 'uppercase', color: '#475569' }}>
                {label}
            </span>
            <StatusPill status={status} />
        </div>
    );

    if (mant.ntipounidad === 1) {
        const dias = calcDiasI(mant.dfechaestimada);
        const st   = stDiasI(dias, mant.ntolerancia);
        const col  = st ? MANT_ST[st].color : '#64748b';
        return (
            <>
                <SectionHdr label="Semirremolque" status={st} />
                <BigMetric
                    value={fmtDiasI(dias)} label="para el próximo servicio" color={col}
                    date={fmtFechaI(mant.dfechaestimada)} dateSub="Mant. Est:"
                />
                <MantRow lbl="Último servicio" val={fmtFechaI(mant.dotfecha)} />
                <MantRow lbl="Estado"          val={mant.bprogramado ? 'Programado' : 'No programado'} />
            </>
        );
    }

    if (mant.ntipounidad === 2) {
        const rest     = mant.nkmprogramado - mant.nkm;
        const st       = stKmI(rest, mant.ntolerancia);
        const col      = MANT_ST[st].color;
        const progreso = Math.round(100 - ((rest * 100) / mant.nfactor));
        return (
            <>
                <SectionHdr label="Remolcador" status={st} />
                <BigMetric
                    value={fmtKmI(rest)} label="km restantes para servicio" color={col}
                    date={fmtFechaI(mant.dfechaestimada)} dateSub="Mant. Est:"
                />
                <KmProgressBar pct={progreso} color={col} />
                <MantRow lbl="Km actual"  val={fmtKmI(mant.nkm)} />
                <MantRow lbl="Fecha Km"   val={fmtFechaI(mant.dfechakm)} />
                <MantRow lbl="Km prog."   val={fmtKmI(mant.nkmprogramado)} />
                <MantRow lbl="Estado"          val={mant.bprogramado ? 'Programado' : 'No programado'} />
                
            </>
        );
    }

    if (mant.ntipounidad === 3) {
        const dias = calcDiasI(mant.dfechaprogramada);
        const st   = stDiasI(dias, mant.ntolerancia);
        const col  = st ? MANT_ST[st].color : '#64748b';
        return (
            <>
                <SectionHdr label="Modular" status={st} />
                <BigMetric
                    value={fmtDiasI(dias)} label="para el próximo servicio" color={col}
                    date={fmtFechaStrI(mant.dfechaprogramada)} dateSub="Programado:"
                />
                <MantRow lbl="Último servicio" val={fmtFechaStrI(mant.dfechaejecutada)} />
                {mant.ntolerancia != null && (
                    <MantRow lbl="Tolerancia" val={`${mant.ntolerancia} día${mant.ntolerancia !== 1 ? 's' : ''}`} />
                )}
                <MantRow lbl="Estado"          val={mant.bprogramado ? 'Programado' : 'No programado'} />
            </>
        );
    }

    return <span style={{ fontSize: '.8rem', color: '#64748b' }}>Tipo de unidad no reconocido</span>;
}

const MiniSpinner = () => (
    <div style={{ display: 'flex', alignItems: 'center', gap: '.5rem', color: '#475569', padding: '.1rem 0' }}>
        <div style={{
            width: 14, height: 14, borderRadius: '50%',
            border: '2px solid #e2e8f0', borderTopColor: '#64748b',
            animation: 'ini-spin .75s linear infinite', flexShrink: 0,
        }} />
        <span style={{ fontSize: '.78rem' }}>Verificando...</span>
    </div>
);

export function Inicio() {
    const navigate = useNavigate();
    const [params] = useSearchParams();

    const [codigo, setCodigo] = useState(params.get('codigo') ?? '');
    const idactivo = params.get('idactivo') ?? '';
    const [tipo, setTipo] = useState(params.get('tipo') ?? '');

    const [clave, setClave] = useState("");
    const [mensaje, setMensaje] = useState("");
    const [activo, setActivo] = useState(null);
    const [tipovehiculo, setTipoVehiculo] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [cargando, setCargando] = useState(1);
    const [invStatus, setInvStatus] = useState(null);
    const [mantStatus, setMantStatus] = useState(undefined);

    useEffect(() => {
        const fetchAsset = apiService.get("api/etiqueta/show/" + idactivo);
        const fetchInv = fetch(process.env.REACT_APP_INVENTARIO_API_URL + "api/inventario/obtenerInventarioActualxidActivo/" + idactivo)
            .then(r => r.json())
            .catch(() => ({ rest: 0 }));

        Promise.all([fetchAsset, fetchInv])
            .then(([assetRes, invRes]) => {
                setActivo(assetRes);
                if (assetRes.rest == 1) {
                    setCodigo(assetRes.activo.codigo);
                    setTipo(assetRes.activo.tipo);
                    if (assetRes.activo.tipo === 'flota') {
                        setTipoVehiculo(assetRes.activo.vehiculo?.idcarroceria ?? 23);
                        const placa = assetRes.activo.vehiculo?.placa;
                        if (placa) {
                            mantenimientoService.getResumenXPlaca(placa)
                                .then(data => setMantStatus(data ?? null))
                                .catch(() => setMantStatus(null));
                        } else {
                            setMantStatus(null);
                        }
                    }
                    setCargando(2);
                } else {
                    setCargando(3);
                }
                setInvStatus(invRes.rest == 1 ? invRes.inventario : false);
            })
            .catch(error => {
                console.error("Error:", error);
                setCargando(3);
                setInvStatus(false);
            });
    }, []);

    const validarYNavegar = (destino) => {
        setIsLoading(true);
        setMensaje("");
        apiService.post("api/personal/validar", { codigo, clave })
            .then(res => {
                setIsLoading(false);
                if (res.respuesta == 1) {
                    navigate(destino(res));
                } else {
                    setMensaje("Clave incorrecta. Inténtelo de nuevo.");
                }
            })
            .catch(error => {
                console.error("Error:", error);
                setIsLoading(false);
                setMensaje("Error de conexión. Intente nuevamente.");
            });
    };

    const handleInventarioFlota = e => {
        e.preventDefault();
        const placa = activo?.activo?.vehiculo?.placa ?? '';
        validarYNavegar(res =>
            `/activo/resumen/?idactivo=${idactivo}&tipo=${tipo}&codigo=${codigo}&idpersonal=${res.personal.idpersonal}&tipovehiculo=${tipovehiculo}&placa=${placa}`
        );
    };

    const handleRegistrarActivo = e => {
        e.preventDefault();
        validarYNavegar(() =>
            `/activo/registro/?idactivo=${idactivo}&tipo=${tipo}&codigo=${codigo}&accion=${cargando}&tipo=flota`
        );
    };

    const isFlota   = tipo === 'flota';
    const isGeneral = tipo === 'general';
    const placa     = activo?.activo?.vehiculo?.placa ?? '';

    return (
        <>
            <style>{`
                /* ── Spin keyframe ── */
                @keyframes ini-spin { to { transform: rotate(360deg); } }
                @keyframes ini-spin-lg { to { transform: rotate(360deg); } }

                /* ── Layout ── */
                .inicio-layout {
                    display: flex; flex-direction: column;
                    min-height: calc(100vh - 80px);
                }
                .inicio-brand-panel { display: none; }
                .inicio-form-panel {
                    flex: 1; display: flex; align-items: center; justify-content: center;
                    padding: 1.5rem 1rem 3rem; background: #f0f2f8;
                }
                @media (min-width: 900px) {
                    .inicio-layout { flex-direction: row; }
                    .inicio-brand-panel {
                        display: flex; flex: 0 0 400px; flex-direction: column;
                        justify-content: center; align-items: flex-start;
                        padding: 3rem 3rem 3rem 3.5rem;
                        background: linear-gradient(145deg, #e12d31 0%, #83090b 100%);
                        position: relative; overflow: hidden;
                    }
                }
                .brand-circle-1 {
                    position: absolute; border-radius: 50%;
                    background: rgba(255,255,255,.06);
                    width: 300px; height: 300px; top: -80px; right: -80px;
                }
                .brand-circle-2 {
                    position: absolute; border-radius: 50%;
                    background: rgba(255,255,255,.04);
                    width: 220px; height: 220px; bottom: -60px; left: -60px;
                }
                .brand-feature {
                    display: flex; align-items: center; gap: .75rem;
                    color: rgba(255,255,255,.75); font-size: .85rem; margin-bottom: .6rem;
                }
                .brand-feature-dot {
                    width: 24px; height: 24px; flex-shrink: 0;
                    background: rgba(255,255,255,.15); border-radius: 50%;
                    display: flex; align-items: center; justify-content: center;
                }

                /* ── Card ── */
                .ini-card {
                    width: 100%; max-width: 440px;
                    border-radius: 1.25rem;
                    box-shadow: 0 4px 6px rgba(0,0,0,.04), 0 16px 48px rgba(0,0,0,.10);
                    border: 1px solid rgba(0,0,0,.06);
                    overflow: hidden; background: #fff;
                }

                /* Mobile header */
                .ini-mobile-hdr {
                    background: linear-gradient(135deg, #e12d31 0%, #83090b 100%);
                    padding: 1.5rem 2rem 1.35rem;
                    position: relative; overflow: hidden;
                    text-align: center;
                }
                .ini-mobile-hdr::before {
                    content: ''; position: absolute; top: -40px; right: -40px;
                    width: 140px; height: 140px; background: rgba(255,255,255,.06); border-radius: 50%;
                }
                .ini-mobile-hdr::after {
                    content: ''; position: absolute; bottom: -60px; left: -20px;
                    width: 180px; height: 180px; background: rgba(255,255,255,.04); border-radius: 50%;
                }
                .ini-logo-ring {
                    width: 52px; height: 52px; background: rgba(255,255,255,.15);
                    border: 2px solid rgba(255,255,255,.22); border-radius: 50%;
                    display: flex; align-items: center; justify-content: center;
                    margin: 0 auto .75rem; position: relative; z-index: 1;
                }
                @media (min-width: 900px) { .ini-mobile-hdr { display: none; } }

                /* ── Card body ── */
                .ini-body { padding: 1.4rem 1.4rem 0; }

                /* ── Asset identity ── */
                .ini-asset {
                    display: flex; align-items: flex-start; justify-content: space-between;
                    gap: 1rem; padding-bottom: 1.1rem; margin-bottom: 1.2rem;
                    border-bottom: 1.5px solid #f1f5f9;
                }
                .ini-asset-eyebrow {
                    font-size: .63rem; font-weight: 700; letter-spacing: .1em;
                    text-transform: uppercase; color: #475569; margin-bottom: .18rem;
                }
                .ini-asset-code {
                    font-size: 1.45rem; font-weight: 800; color: #0f172a;
                    letter-spacing: -.03em; line-height: 1.1;
                }
                .ini-asset-plate {
                    display: inline-flex; align-items: center; gap: .35rem;
                    font-size: .78rem; color: #64748b; margin-top: .28rem;
                    background: #f8fafc; border: 1px solid #e2e8f0;
                    padding: .18rem .55rem; border-radius: .4rem;
                }
                .ini-type-badge {
                    display: inline-flex; align-items: center; gap: .3rem; flex-shrink: 0;
                    font-size: .63rem; font-weight: 700; letter-spacing: .05em; text-transform: uppercase;
                    padding: .3rem .75rem; border-radius: 100px; margin-top: 2px;
                }
                .ini-flota   { background: #fff1f2; color: #c81e22; border: 1px solid #fecaca; }
                .ini-general { background: #f0fdf4; color: #15803d; border: 1px solid #bbf7d0; }

                /* ── Info panels ── */
                .ini-panels { display: flex; flex-direction: column; gap: .75rem; margin-bottom: 1.2rem; }
                .ini-panel {
                    border-radius: .875rem; border: 1px solid #f1f5f9; overflow: hidden;
                }
                .ini-panel-hdr {
                    display: flex; align-items: center; gap: .6rem;
                    padding: .65rem 1rem; background: #fafafa; border-bottom: 1px solid #f1f5f9;
                }
                .ini-panel-icon {
                    width: 28px; height: 28px; border-radius: .45rem; flex-shrink: 0;
                    display: flex; align-items: center; justify-content: center; font-size: .8rem;
                }
                .ini-panel-title { font-size: .8rem; font-weight: 700; color: #0f172a; letter-spacing: -.01em; }
                .ini-panel-body { padding: .8rem 1rem; }

                /* ── Inventory status ── */
                .ini-inv-row {
                    display: flex; align-items: center; gap: .6rem;
                }
                .ini-inv-dot {
                    width: 26px; height: 26px; border-radius: 50%; flex-shrink: 0;
                    display: flex; align-items: center; justify-content: center;
                }

                /* ── Action section ── */
                .ini-action {
                    background: #f8fafc; border-top: 1.5px solid #f1f5f9;
                    padding: 1.2rem 1.4rem 1.4rem;
                }
                .ini-pin-label {
                    display: block; font-size: .68rem; font-weight: 700;
                    letter-spacing: .08em; text-transform: uppercase; color: #334155;
                    margin-bottom: .45rem;
                }
                .ini-pin-wrap { position: relative; margin-bottom: .9rem; }
                .ini-pin-icon {
                    position: absolute; left: .9rem; top: 50%;
                    transform: translateY(-50%); color: #94a3b8; font-size: .9rem; pointer-events: none;
                }
                .ini-pin-input {
                    width: 100%; padding: .8rem 1rem .8rem 2.5rem;
                    border: 1.5px solid #e2e8f0; border-radius: .75rem;
                    font-size: 1rem; letter-spacing: .18em; background: #fff;
                    color: #1e293b; outline: none;
                    transition: border-color .2s, box-shadow .2s;
                }
                .ini-pin-input:focus {
                    border-color: #e12d31;
                    box-shadow: 0 0 0 3px rgba(225,45,49,.1);
                }
                .ini-pin-input::placeholder { letter-spacing: .04em; color: #cbd5e1; }

                /* ── Error ── */
                .ini-error {
                    display: flex; align-items: center; gap: .5rem;
                    background: #fff5f5; border: 1px solid #fecaca;
                    border-radius: .75rem; padding: .7rem .95rem;
                    color: #b91c1c; font-size: .82rem; font-weight: 500;
                    margin-bottom: .9rem;
                }

                /* ── Buttons ── */
                .ini-btn {
                    width: 100%; padding: .875rem 1rem; border-radius: .875rem;
                    font-size: .92rem; font-weight: 600; border: none;
                    display: flex; align-items: center; justify-content: center; gap: .5rem;
                    cursor: pointer; transition: opacity .2s, transform .15s, box-shadow .2s;
                }
                .ini-btn:disabled { opacity: .65; cursor: not-allowed; }
                .ini-btn:not(:disabled):hover { transform: translateY(-1px); }
                .ini-btn-red {
                    background: linear-gradient(135deg, #e12d31, #83090b); color: #fff;
                    box-shadow: 0 4px 14px rgba(225,45,49,.28);
                }
                .ini-btn-red:not(:disabled):hover { box-shadow: 0 6px 20px rgba(225,45,49,.4); }
                .ini-btn-dark {
                    background: linear-gradient(135deg, #0f172a, #1e293b); color: #fff;
                    box-shadow: 0 4px 14px rgba(15,23,42,.22);
                }

                /* ── Loading & not-found ── */
                .ini-state-wrap { padding: 2rem 1.4rem; text-align: center; }
                .ini-spin-lg {
                    width: 40px; height: 40px; border-radius: 50%;
                    border: 3px solid #fde8e8; border-top-color: #e12d31;
                    animation: ini-spin-lg .8s linear infinite; margin: 0 auto .875rem;
                }
                .ini-nf-icon {
                    width: 64px; height: 64px; background: #fef9c3; border-radius: 50%;
                    display: flex; align-items: center; justify-content: center;
                    margin: 0 auto 1rem;
                }
            `}</style>

            <div className="inicio-layout">

                {/* ── Brand panel (desktop) ── */}
                <div className="inicio-brand-panel">
                    <div className="brand-circle-1"></div>
                    <div className="brand-circle-2"></div>
                    <div style={{ position: 'relative', zIndex: 1 }}>
                        <div style={{
                            width: 64, height: 64, borderRadius: '50%',
                            background: 'rgba(255,255,255,.15)', border: '2px solid rgba(255,255,255,.22)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1.5rem',
                        }}>
                            <i className="bi bi-list text-white" style={{ fontSize: '1.5rem' }}></i>
                        </div>
                        <h1 style={{ color: '#fff', fontWeight: 800, fontSize: '2rem', margin: '0 0 .25rem', letterSpacing: '.02em' }}>
                            HAGEMSA
                        </h1>
                        <p style={{ color: 'rgba(255,255,255,.6)', fontSize: '.8rem', letterSpacing: '.08em', textTransform: 'uppercase', margin: '0 0 2.5rem' }}>
                            Gestion de Activos
                        </p>
                        <div style={{ borderTop: '1px solid rgba(255,255,255,.15)', paddingTop: '1.75rem' }}>
                            {[
                                { icon: 'bi-qr-code-scan', text: 'Escaneo de activos por QR' },
                                { icon: 'bi-clipboard2-check', text: 'Control de inventario periódico' },
                                { icon: 'bi-tools', text: 'Seguimiento de mantenimiento' },
                            ].map(f => (
                                <div key={f.icon} className="brand-feature">
                                    <div className="brand-feature-dot">
                                        <i className={`bi ${f.icon}`} style={{ color: '#fff', fontSize: '.75rem' }}></i>
                                    </div>
                                    {f.text}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* ── Form panel ── */}
                <div className="inicio-form-panel">
                    <div style={{ width: '100%', maxWidth: 440 }}>
                        <div className="ini-card">

                            {/* Mobile header */}
                            <div className="ini-mobile-hdr">
                                <div className="ini-logo-ring">
                                    <i className="bi bi-box-seam-fill text-white" style={{ fontSize: '1.1rem' }}></i>
                                </div>
                                <div style={{ position: 'relative', zIndex: 1 }}>
                                    <h1 className="text-white fw-bold mb-1" style={{ fontSize: '1.25rem', letterSpacing: '.03em' }}>HAGEMSA</h1>
                                    <p className="mb-0" style={{ color: 'rgba(255,255,255,.5)', fontSize: '.7rem', letterSpacing: '.07em' }}>
                                        GESTIÓN DE INVENTARIO DE ACTIVOS
                                    </p>
                                </div>
                            </div>

                            {/* ── Loading ── */}
                            {cargando === 1 && (
                                <div className="ini-state-wrap">
                                    <div className="ini-spin-lg"></div>
                                    <p className="mb-0" style={{ color: '#334155', fontSize: '.88rem' }}>Verificando activo...</p>
                                </div>
                            )}

                            {/* ── Asset found ── */}
                            {cargando === 2 && activo?.rest === 1 && (
                                <>
                                    <div className="ini-body">

                                        {/* Asset identity */}
                                        <div className="ini-asset">
                                            <div>
                                                <div className="ini-asset-eyebrow">Activo</div>
                                                <div className="ini-asset-code">{codigo}</div>
                                                {isFlota && placa && (
                                                    <div style={{ marginTop: '.28rem' }}>
                                                        <span className="ini-asset-plate">
                                                            <i className="bi bi-card-text"></i>
                                                            # {idactivo}
                                                        </span>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="pt-1">
                                                {isFlota   && <span className="ini-type-badge ini-flota"><i className="bi bi-truck"></i>Flota</span>}
                                                {isGeneral && <span className="ini-type-badge ini-general"><i className="bi bi-archive"></i>General</span>}
                                            </div>
                                        </div>

                                        {/* Info panels */}
                                        <div className="ini-panels">

                                            {/* Inventory panel */}
                                            <div className="ini-panel">
                                                <div className="ini-panel-hdr">
                                                    <div className="ini-panel-icon" style={{ background: '#fdf2f2' }}>
                                                        <i className="bi bi-clipboard2-check" style={{ color: '#c81e22' }}></i>
                                                    </div>
                                                    <span className="ini-panel-title">Inventario</span>
                                                </div>
                                                <div className="ini-panel-body">
                                                    {invStatus === null && <MiniSpinner />}
                                                    {invStatus === false && (
                                                        <div className="ini-inv-row">
                                                            <div className="ini-inv-dot" style={{ background: '#fef9c3' }}>
                                                                <i className="bi bi-hourglass-split" style={{ color: '#d97706', fontSize: '.72rem' }}></i>
                                                            </div>
                                                            <div>
                                                                <div style={{ fontSize: '.82rem', fontWeight: 600, color: '#b45309' }}>Pendiente en este periodo</div>
                                                                <div style={{ fontSize: '.72rem', color: '#64748b', marginTop: '.1rem' }}>Aún no ha sido inventariado</div>
                                                            </div>
                                                        </div>
                                                    )}
                                                    {invStatus && (
                                                        <div className="ini-inv-row">
                                                            <div className="ini-inv-dot" style={{ background: '#dcfce7' }}>
                                                                <i className="bi bi-check-lg" style={{ color: '#16a34a', fontSize: '.8rem' }}></i>
                                                            </div>
                                                            <div>
                                                                <div style={{ fontSize: '.82rem', fontWeight: 600, color: '#15803d' }}>Inventariado en este periodo</div>
                                                                {invStatus.observacion && (
                                                                    <div style={{ fontSize: '.72rem', color: '#64748b', marginTop: '.1rem' }}>{invStatus.observacion}</div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            {/* Maintenance panel (flota only) */}
                                            {isFlota && (
                                                <div className="ini-panel">
                                                    <div className="ini-panel-hdr">
                                                        <div className="ini-panel-icon" style={{ background: '#eff6ff' }}>
                                                            <i className="bi bi-tools" style={{ color: '#1d4ed8' }}></i>
                                                        </div>
                                                        <span className="ini-panel-title">Mantenimiento preventivo</span>
                                                    </div>
                                                    <div className="ini-panel-body">
                                                        {mantStatus === undefined
                                                            ? <MiniSpinner />
                                                            : <MantPreventivo mant={mantStatus} />
                                                        }
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* Action section */}
                                    <div className="ini-action">
                                        {mensaje && (
                                            <div className="ini-error">
                                                <i className="bi bi-exclamation-circle-fill flex-shrink-0"></i>
                                                <span>{mensaje}</span>
                                            </div>
                                        )}
                                        <label className="ini-pin-label" htmlFor="clave">Clave de acceso</label>
                                        <div className="ini-pin-wrap">
                                            <i className="bi bi-shield-lock ini-pin-icon"></i>
                                            <input
                                                type="password" id="clave" className="ini-pin-input"
                                                placeholder="Ingrese su clave"
                                                value={clave} onChange={e => setClave(e.target.value)}
                                                autoComplete="current-password"
                                            />
                                        </div>
                                        {isFlota && (
                                            <button className="ini-btn ini-btn-red" onClick={handleInventarioFlota} disabled={isLoading}>
                                                {isLoading
                                                    ? <><span className="spinner-border spinner-border-sm" role="status"></span> Verificando...</>
                                                    : <><i className="bi bi-search"></i> Ver información</>
                                                }
                                            </button>
                                        )}
                                        {isGeneral && (
                                            <button className="ini-btn ini-btn-dark" onClick={handleRegistrarActivo} disabled={isLoading}>
                                                {isLoading
                                                    ? <><span className="spinner-border spinner-border-sm" role="status"></span> Verificando...</>
                                                    : <><i className="bi bi-plus-circle"></i> Completar registro</>
                                                }
                                            </button>
                                        )}
                                    </div>
                                </>
                            )}

                            {/* ── Not found ── */}
                            {cargando === 3 && (
                                <div className="ini-state-wrap">
                                    <div className="ini-nf-icon">
                                        <i className="bi bi-qr-code text-warning" style={{ fontSize: '1.6rem' }}></i>
                                    </div>
                                    <h5 className="fw-bold mb-1" style={{ color: '#1e293b' }}>Activo no encontrado</h5>
                                    <p className="mb-4" style={{ color: '#334155', fontSize: '.875rem' }}>
                                        La etiqueta <strong>#{idactivo}</strong> no está registrada.<br />Contacte con el área de TI.
                                    </p>
                                    <button
                                        className="btn btn-outline-secondary btn-sm"
                                        style={{ borderRadius: '.625rem', padding: '.4rem 1.2rem' }}
                                        onClick={() => window.location.reload()}
                                    >
                                        <i className="bi bi-arrow-clockwise me-1"></i> Reintentar
                                    </button>
                                </div>
                            )}

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
